import { formatRelativeTime } from "@/lib/utils";
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from "@a7y/tailwind-catalyst";
import type { AdminOrganizationDetail } from "@a7y/types";
import { FileText } from "lucide-react";
import { TX_TYPE_LABELS } from "./constants";
import { Section } from "./shared";

export interface BillingTabProps {
  transactions: AdminOrganizationDetail["transactions"];
}

export function BillingTab({ transactions }: BillingTabProps) {
  return (
    <Section title="Transaction History" icon={<FileText className="h-5 w-5" />}>
      <Table className="[--gutter:--spacing(6)] sm:[--gutter:--spacing(8)]">
        <TableHead>
          <TableRow>
            <TableHeader>Type</TableHeader>
            <TableHeader>Applied By</TableHeader>
            <TableHeader>Reason</TableHeader>
            <TableHeader>Date</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center">
                <Text className="text-zinc-500">No transactions found</Text>
              </TableCell>
            </TableRow>
          ) : (
            transactions.map((tx) => (
              <TableRow key={tx.transactionId}>
                <TableCell>
                  <Badge color="zinc">
                    {TX_TYPE_LABELS[tx.type]}
                  </Badge>
                </TableCell>
                <TableCell className="font-medium">
                  {tx.appliedBy || "system"}
                </TableCell>
                <TableCell className="max-w-xs truncate text-zinc-500">
                  {tx.reason || "-"}
                </TableCell>
                <TableCell className="text-zinc-500">
                  {formatRelativeTime(tx.timestamp)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Section>
  );
}
